import {Utils} from "./utils";

export const PREFIX_KEY = "respira_yoga_prod";

// Local Storage KEY
export const LS_TOKEN_KEY = PREFIX_KEY + "token_user";
export const LS_TOKEN_CONSUMER_KEY = PREFIX_KEY + "token_consumer_user";
export const LS_USER_KEY = PREFIX_KEY + "user_json";
export const LS_USER_CONSUMER_KEY = PREFIX_KEY + "user_consumer_json";

export const LS_DEFAULT_LANGUAGE_KEY = PREFIX_KEY + "language";
export const LS_DEFAULT_CURRENCY_KEY = PREFIX_KEY + "currency";
export const LS_DEFAULT_TIMEZONE_KEY = PREFIX_KEY + "timezone";
export const LS_DEFAULT_COUNTRY_CODE_KEY = PREFIX_KEY + "country_code";

// URLs
export const BASE_URL_API = "https://api.respira.yoga/v1/";
export const URL_API_USER = "users/";
export const URL_API_CLIENT_ADMIN = "clients-admin/";
export const URL_API_LOCATIONS = "locations/";
export const URL_API_CLIENT = "clients/";
export const URL_API_RESERVATION = "reservations/";
export const URL_API_RATES = "rates/";
export const URL_API_COMPANY = "company/";
export const URL_API_APPOINTMENTS= "appointments/";
export const URL_API_APPOINTMENT_SET = "appointment_sets/";
export const URL_API_ORDERS= "orders/";
export const URL_API_PAYOUTS = "payouts/";
export const URL_API_VIDEOS = "content/videos/";
export const URL_API_SHOWCASES = "content/showcases/";
export const URL_STATEMENT = "statement/";


export const URL_API_RELATIVE_APPOINTMENT = "appointments";
export const URL_API_RELATIVE_CANCEL = "cancel";
export const URL_API_RELATIVE_NO_SHOW = "no_show";
export const URL_API_RELATIVE_SHOW = "show";
export const URL_API_RELATIVE_SUBSCRIPTION = "subscriptions";
export const URL_API_RELATIVE_CLIENTS = "clients";
export const URL_API_RELATIVE_SUBSCRIPTION_VALID = URL_API_RELATIVE_SUBSCRIPTION + "/valid";
export const URL_API_RELATIVE_ORDER = "orders";
export const URL_API_RELATIVE_TRANSACTIONS = "transactions";
export const URL_API_RELATIVE_RESERVATION = "reservations";
export const URL_API_RELATIVE_APPOINTMENT_SET = "appointment_sets";
export const URL_API_SUBSCRIPTIONS_TYPE = "subscriptions/type";
export const URL_API_COMPANY_USERNAME = "username";
export const URL_API_RELATIVE_CATEGORY = "category";
export const URL_API_RELATIVE_GET_JOIN_URL = "meeting_join_url";
export const URL_API_RELATIVE_ACTIVE_SUBSCRIPTIONS = "active";
export const URL_API_RELATIVE_UPLOAD = "upload";
export const URL_API_RELATIVE_UPLOAD_COMPLETE = "complete";
export const URL_API_RELATIVE_VIDEO = "videos";
export const URL_API_RELATIVE_VIDEO_ARCHIVE = "archive";

export const URL_API_CLIENT_ADMIN_ME = URL_API_CLIENT_ADMIN + "me/";
export const URL_API_COMPANY_ME = URL_API_COMPANY + "me/";


export const URL_API_USER_LOGIN = URL_API_USER + "auth_token/";

export const URL_MEETING_ADMIN = 'https://manager.respira.yoga/admin_meeting.html';
export const URL_BOOKING = 'https://booking.respira.yoga/';
export const URL_SHOWCASE = 'https://showcase.respira.yoga/';

export const URL_API_CONSUMER = 'consumer/';
export const URL_API_CONSUMER_USER = URL_API_CONSUMER +'users/';
export const URL_API_CONSUMER_USER_ME =  URL_API_CONSUMER_USER + 'me/';
export const URL_API_CONSUMER_SHOWCASES = URL_API_CONSUMER + "showcases/";
export const URL_API_CONSUMER_RELATIVE_CHECKOUT = 'checkout';

export const URL_API_ACTIVATE_USER = URL_API_CONSUMER_USER + "activate/";

export const URL_CURRENCIES = BASE_URL_API + "consumer/currencies/";


export const STRIPE_PUBLIC_KEY = 'pk_live_51HiuvPGVSB4LlWHcl3bEI9toxAD38Tfr4qkdkDb3nPnnidOWzkjxKmPsrZipLUSmvV5MouYEdF9KuU83IubYYeNT004hCiCKBi';

export const STRIPE_APPLICATION_FEE_PERCENT = 5;
export const VAT_PERCENT = 22;
export const STRIPE_FIXED_TAX = 0.30;

export const TIMEZONE_DEFAULT = 'Europe/Rome';
export const CURRENCY_DEFAULT = 'EUR';
export const COUNTRY_DEFAULT = 'IT';

// ENUMs
export const CLIENT_ADMIN_ROLE = {
    SUPER_ADMIN: 0,
    ADMIN: 1
};

export const CLIENT_ADMIN_PERMISSION = {
    RESERVATION: 0,
    ADMINISTRATION: 1,
    CONFIGURATION: 2
};

export const RATE_TYPE = {
    INDIVIDUAL : 0,
    GROUP : 1,
    COURSE : 2
};

export const SUBSCRIPTION_CATEGORY = {
    NORMAL : 0,
    CARNET : 1
};

export const PAYMENT_MODE = {
    CASH: 1,
    POS: 2,
    CREDIT_CARD: 3,
    TRANSFER: 4,
    TO_PAY: 5,
    OTHER: 6
};

export const PAYMENT_MODE_SUBSCRIPTION = -1;

export const CHANNEL_MODE = {
    OFFLINE: 0,
    ONLINE: 1
};

export const STATE_RESERVATION = {
    STATE_PENDING: 0,
    STATE_COMPLETED: 1,
    STATE_CANCELED: 2,
    STATE_NO_SHOW: 3
};

export const STATE_ORDER = {
    STATE_COMPLETED: 1,
    STATE_PAYMENT_REQUIRED: 2,
    STATE_CANCELED: 3
};

export const STATUS_STRIPE_PAYOUNT = {
    PAID : "paid",
    PENDING : "pending",
    TRANSIT : "in_transit",
    CANCELED : "canceled",
    FAILED : "falied"
};



export const STRIPE_BUSINESS_TYPE = {
    INDIVIDUAL: "individual",
    COMPANY: "company",
    NON_PROFIT: "non_profit"
};

export const LANGUAGE = {
    IT: "it",
    EN: "en"
};

export const VIDEO_STATE = {
    READY: 0,
    STATE_TO_UPLOAD: 1,
    STATE_TRANSCODING: 2
};

export const VIDEO_VISIBILITY = {
    PUBLIC: 0,
    NOT_PUBLIC: 1
};

export const SHOWCASE_PRIVACY = {
    ANYONE: 0,
    PASSWORD: 1,
    PURCHASED: 2,
    NOT_VISIBLE: 3,
};

export const CURRENCY = {
    EUR: 'EUR',
    USD: 'USD',
    CAD: 'CAD',
    CHF: 'CHF',
    GBP: 'GBP'
};

export const ORDER_ITEM_TYPE = {
    RESERVATION_TYPE: 0,
    SUBSCRIPTION_TYPE: 1,
    SHOWCASE_TYPE: 2
};


// Options

export const RATE_TYPE_OPTIONS = () => { return [
    { "name": Utils.getStringRateType(RATE_TYPE.INDIVIDUAL), "value": RATE_TYPE.INDIVIDUAL },
    { "name": Utils.getStringRateType(RATE_TYPE.GROUP), "value": RATE_TYPE.GROUP },
    { "name": Utils.getStringRateType(RATE_TYPE.COURSE), "value": RATE_TYPE.COURSE }
]};

export const SUBSCRIPTION_CATEGORY_OPTIONS = () => { return [
    { "name": Utils.getStringSubscriptionCategory(SUBSCRIPTION_CATEGORY.NORMAL), "value": SUBSCRIPTION_CATEGORY.NORMAL },
    { "name": Utils.getStringSubscriptionCategory(SUBSCRIPTION_CATEGORY.CARNET), "value": SUBSCRIPTION_CATEGORY.CARNET }
]};

export const PAYMENT_MODE_OPTIONS = () => { return [
    {"name": Utils.getStringPaymentMode(PAYMENT_MODE.CASH), "value": PAYMENT_MODE.CASH},
    {"name": Utils.getStringPaymentMode(PAYMENT_MODE.POS), "value": PAYMENT_MODE.POS},
    {"name": Utils.getStringPaymentMode(PAYMENT_MODE.CREDIT_CARD), "value": PAYMENT_MODE.CREDIT_CARD},
    {"name": Utils.getStringPaymentMode(PAYMENT_MODE.TRANSFER), "value": PAYMENT_MODE.TRANSFER},
    {"name": Utils.getStringPaymentMode(PAYMENT_MODE.TO_PAY), "value": PAYMENT_MODE.TO_PAY},
    {"name": Utils.getStringPaymentMode(PAYMENT_MODE.OTHER), "value": PAYMENT_MODE.OTHER}
]};

export const VIDEO_VISIBILITY_OPTIONS = () => { return [
    { "name": Utils.getStringVisibilityVideo(VIDEO_VISIBILITY.PUBLIC), "value": VIDEO_VISIBILITY.PUBLIC},
    { "name": Utils.getStringVisibilityVideo(VIDEO_VISIBILITY.NOT_PUBLIC), "value": VIDEO_VISIBILITY.NOT_PUBLIC}
]};


export const LANGUAGE_OPTIONS = () => { return [
    { "name": Utils.getStringLanguage(LANGUAGE.IT), "value": LANGUAGE.IT},
    { "name": Utils.getStringLanguage(LANGUAGE.EN), "value": LANGUAGE.EN}
]};

export const SHOWCASE_PRIVACY_OPTIONS = () => { return [
    { "name": Utils.getStringPrivacyShowcase(SHOWCASE_PRIVACY.ANYONE), "value": SHOWCASE_PRIVACY.ANYONE},
    { "name": Utils.getStringPrivacyShowcase(SHOWCASE_PRIVACY.PASSWORD), "value": SHOWCASE_PRIVACY.PASSWORD},
    { "name": Utils.getStringPrivacyShowcase(SHOWCASE_PRIVACY.PURCHASED), "value": SHOWCASE_PRIVACY.PURCHASED},
    { "name": Utils.getStringPrivacyShowcase(SHOWCASE_PRIVACY.NOT_VISIBLE), "value": SHOWCASE_PRIVACY.NOT_VISIBLE}
]};


export const CURRENCY_OPTIONS = () => { return [
    { "symbol": Utils.getCurrencySymbolFromString(CURRENCY.EUR), "value": CURRENCY.EUR},
    { "symbol": Utils.getCurrencySymbolFromString(CURRENCY.USD), "value": CURRENCY.USD},
    { "symbol": Utils.getCurrencySymbolFromString(CURRENCY.CAD), "value": CURRENCY.CAD},
    { "symbol": Utils.getCurrencySymbolFromString(CURRENCY.CHF), "value": CURRENCY.CHF},
    { "symbol": Utils.getCurrencySymbolFromString(CURRENCY.GBP), "value": CURRENCY.GBP}
]};

export const MONTH_LIST = [
    {value: 0, name: "1"},
    {value: 1, name: "2"},
    {value: 2, name: "3"},
    {value: 3, name: "4"},
    {value: 4, name: "5"},
    {value: 5, name: "6"},
    {value: 6, name: "7"},
    {value: 7, name: "8"},
    {value: 8, name: "9"},
    {value: 9, name: "10"},
    {value: 10, name: "11"},
    {value: 11, name: "12"},
]


export const LIMIT_RECORDS_API = 20;
